import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('idea', [
      'getRevenueStreams',
      'getStartupCosts',
      'getStaffAndPayrolls',
      'getDirectCosts',
      'getMarketingElements',
      'getOtherOverheads',
      'getFinances'
    ]),

    hasRevenueStreams () {
      return this.getRevenueStreams.length > 0
    },

    hasStartupCosts () {
      return this.getStartupCosts.length > 0
    },

    hasStaffAndPayrolls () {
      return this.getStaffAndPayrolls.length > 0
    },

    hasDirectCosts () {
      return this.getDirectCosts.length > 0
    },

    hasMarketingElements () {
      return this.getMarketingElements.length > 0
    },

    hasOtherOverheads () {
      return this.getOtherOverheads.length > 0
    },

    hasFinances () {
      return this.getFinances.length > 0
    },

    completedFinancialSectionsCount () {
      return [
        this.hasRevenueStreams,
        this.hasStartupCosts,
        this.hasStaffAndPayrolls,
        this.hasDirectCosts,
        this.hasMarketingElements,
        this.hasOtherOverheads,
        this.hasFinances
      ].filter(Boolean).length
    },

    totalFinancialsSections () {
      return 7
    },

    isAllFinancialSectionsCompleted () {
      return this.completedFinancialSectionsCount === this.totalFinancialsSections
    },

    financialStatusLabel () {
      return `${this.completedFinancialSectionsCount}/${this.totalFinancialsSections}`
    }
  },

  methods: {
    getFinancialStatus () {
      return {
        completed: this.completedFinancialSectionsCount,
        total: this.totalFinancialsSections
      }
    }
  }
}
